import CharmInfo from './schema/CharmInfo';
import charmInfoStore from './store';
import charmsDatapoints from './datapoints';
import CharmsInfoSchema from './schema/CharmsInfoSchema';
import KeywordInfo from './schema/KeywordInfo';
import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';

import {
    CHARMS_USAGE_SELECTION_TYPE,
    CHARMS_USAGE_GETDEFAULTSET,
    CHARMS_USAGE_SUGGESTIONS_SHOWN,
    CHARMS_USAGE_AUTOSELECT_OVERRIDE_MANUAL,
    CHARMS_USAGE_SOURCE_QUICKCOMPOSE,
    CHARMS_USAGE_SOURCE_CALENDARPICKERCONTEXTMENU,
    CHARMS_USAGE_SOURCE_READINGPANECALENDARCHARM,
    CHARMS_USAGE_SOURCE_CALENDARITEMCONTEXTMENUITEMS,
    CHARMS_USAGE_SOURCE_CHARMPICKERANCHORBUTTON,
} from './datapoints';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CharmsCatalog", webpackPrefetch: true */ './lazyIndex')
);
export interface GetCalendarCharmsInfo {
    charmStore: CharmsInfoSchema;
}

let lazyLoadCharmsCatalog = new LazyAction(lazyModule, m => m.loadCharmsCatalog);
export let lazyLoadCharmSvgTextInMap = new LazyAction(lazyModule, m => m.loadCharmSvgTextInMap);

// Export synchronous utils
export { default as areDefaultCharmsAvailable } from './actions/areDefaultCharmsAvailable';
export { default as getAllCharmKeywords } from './actions/getAllCharmKeywords';
export { default as getCharmForIdFromStore } from './actions/getCharmForIdFromStore';
export { default as getDefaultCharms } from './actions/getDefaultCharms';
export { default as getKeywordInfo } from './actions/getKeywordInfo';
export { default as getCharmForId } from './utils/getCharmForId';
export { default as getCharmForIdOrUnsetCharm } from './utils/getCharmForIdOrUnsetCharm';
export { default as getCharmForKeyword } from './utils/getCharmForKeyword';
export { default as getNoCharmInfoObject } from './utils/getNoCharmInfoObject';
export { default as getEffectiveCharm } from './utils/getEffectiveCharm';

export { CharmInfo };
export { charmInfoStore };
export { KeywordInfo };

export { charmsDatapoints };
export {
    CHARMS_USAGE_SELECTION_TYPE,
    CHARMS_USAGE_GETDEFAULTSET,
    CHARMS_USAGE_SUGGESTIONS_SHOWN,
    CHARMS_USAGE_AUTOSELECT_OVERRIDE_MANUAL,
    CHARMS_USAGE_SOURCE_QUICKCOMPOSE,
    CHARMS_USAGE_SOURCE_CALENDARPICKERCONTEXTMENU,
    CHARMS_USAGE_SOURCE_READINGPANECALENDARCHARM,
    CHARMS_USAGE_SOURCE_CALENDARITEMCONTEXTMENUITEMS,
    CHARMS_USAGE_SOURCE_CHARMPICKERANCHORBUTTON,
};

runAfterInitialRender(lazyLoadCharmsCatalog.importAndExecute);
